import React, { useState, useEffect, useContext, useRef } from "react";
import auth from "services/auth";
// import ls from "local-storage";
import AppContext from "contexts/AppContext";
import { Dropdown } from "react-bootstrap";

import api from "services/api";
// import { Button } from "react-bootstrap";
import { Link, useParams, useHistory, useLocation } from "react-router-dom";
// custom component
import LeftSidebar from "elements/LeftSidebar";
// import RightSidebar from "elements/RightSidebar";
import CashierModals from "elements/dashboard_elements/CashierModals";
// import VaultModals from "elements/dashboard_elements/VaultModals";
import LoginReg from "elements/LoginReg";
import SideNav from "elements/SideNav";
import LanguageSwitcher from "elements/LanguageSwitcher";
import Translator, { __ } from "services/Translator";
import ThemeSettings from "./ThemeSettings";
import SearchPopUp from "./SearchPopUp";
import UserDropDownMenu from "elements/UserDropDownMenu";

const Header = (props) => {
  const toggleSideNav = () => {
    if (props.showSideNav) {
      props.setShowSideNav(false);
    } else {
      props.setShowSideNav(true);
    }
  };
  // const menuOpen = props.menuOpen;
  const params = useParams();
  const history = useHistory();
  const location = useLocation();
  const { updateUserObj } = useContext(AppContext);
  const gamesCategory = params.category;

  const isAuthenticated = props.isAuthenticated;
  const userBalance = props.userBalance;
  const getUserBalance = props.getUserBalance;

  const logout = async (ev) => {
    ev.preventDefault();
    await auth.logout();
    await updateUserObj();
  };

  const notificationCount = props.notificationCount;

  // userMenu
  const [rightSidebarOpen, setRightSidebarOpen] = useState(false);
  const toggleRightSidebar = () => {
    setRightSidebarOpen(!rightSidebarOpen);
  };

  const [leftSidebarOpen, setLeftSidebarOpen] = useState(false);

  const [searchStr, setSearchStr] = useState("");
  const [searchSuggestions, setSearchSuggestions] = useState([]);
  const searchTextBox = useRef(null);

  // expand searcbar
  const [expandSearchBar, setExpandSearchBar] = useState(false);

  const toggleExpandedSearchBar = (force) => {
    if (expandSearchBar) {
      setSearchSuggestions([]);
      if (force === true) {
        setSearchStr("");
        setExpandSearchBar(false);
      } else {
        if (searchStr.length === 0) {
          setExpandSearchBar(false);
        }
      }
    } else {
      setExpandSearchBar(true);
      searchTextBox.current.focus();
    }
  };

  const getSearchSuggestions = async () => {
    if (searchStr.length >= 2) {
      var response = await api.get("/games/search-suggestions", {
        query: searchStr,
        providers: props.selectedProviders,
        extensiveInfo: true,
      });
      if (response.status === 200) {
        setSearchSuggestions(response.data);
      }
    } else {
      setSearchSuggestions([]);
    }
  };

  useEffect(() => {
    getSearchSuggestions();
  }, [searchStr]);

  const doSearchByGameName = (text) => {
    props.setSearchStr(text);
    toggleExpandedSearchBar(true);
    history.push("/games/search");
  };

  //GamePlay Page detection

  const [showInPlay, setShowInPlay] = useState(false);
  const playPath = location.pathname.split("/");

  useEffect(() => {
    setShowInPlay(playPath.includes("play"));
  }, [playPath]);

  // const [modalSignUpPropsData, setModalSignUpPropsData] = useState(false);
  // const [modalLoginPropsData, setModalLoginPropsData] = useState(false);

  const pageName = playPath[1];

  return (
    <>
      <LoginReg {...props} />
      {/* <ThemeSettings {...props} /> */}
      <header>
        <section className="header">
          <div className="header_menu_area">
            <div className="row align-items-center">
              <div className="col-4 col-md-5">
                <div className="header_menu">
                  {props.isMobileDevice && (
                    <div
                      onClick={() => {
                        props.setShowLeftSidebar(!props.showLeftSidebar);
                      }}
                      className="actionBar"
                    >
                      {!props.showLeftSidebar && (
                        <svg
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          class="m-icon foldOutIcon"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M5 7a1 1 0 011-1h14a1 1 0 110 2H6a1 1 0 01-1-1zm-2 5a1 1 0 011-1h16a1 1 0 110 2H4a1 1 0 01-1-1zm7 4a1 1 0 100 2h10a1 1 0 100-2H10z"
                            fill="currentColor"
                          ></path>
                        </svg>
                      )}
                      {props.showLeftSidebar && (
                        <svg
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          class="m-icon foldInIcon"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M5 7a1 1 0 011-1h14a1 1 0 110 2H6a1 1 0 01-1-1zm-2 5a1 1 0 011-1h16a1 1 0 110 2H4a1 1 0 01-1-1zm7 4a1 1 0 100 2h10a1 1 0 100-2H10z"
                            fill="currentColor"
                          ></path>
                        </svg>
                      )}
                    </div>
                  )}

                  <Link
                    // onClick={toggleSideNav}
                    onClick={() => {
                      props.setShowLeftSidebar(!props.showLeftSidebar);
                      // setTimeout(function () {
                      //   props.setShowLeftSidebar(false);
                      // }, 500);
                      // props.setShowLeftSidebar(true);
                    }}
                    className="menu_btn d-none"
                  >
                    <img
                      src={
                        require("../assets/images/new-landing/icons/bars.png")
                          .default
                      }
                      alt="Menu Bar"
                    />
                  </Link>
                  <Link className="d-none d-lg-block" to="/">
                    <span
                      className={
                        pageName === ""
                          ? "indicate active " + props.landingType
                          : "indicate"
                      }
                    ></span>
                    {__("Home")}
                  </Link>
                  <Link className="d-none d-xl-block" to="/promotions">
                    <span
                      className={
                        pageName === "promotions"
                          ? "indicate active " + props.landingType
                          : pageName === "sports-betting"
                          ? "indicate active " + props.landingType
                          : "indicate"
                      }
                    ></span>

                    {__("Promotions")}
                  </Link>
                  <Link className="d-none d-xl-block" to="/vip">
                    <span
                      className={
                        pageName === "vip"
                          ? "indicate active " + props.landingType
                          : "indicate"
                      }
                    ></span>
                    {__("Loyalty & VIP")}
                  </Link>

                  <SearchPopUp {...props} />
                </div>
              </div>
              <div className="col-4 col-md-2">
                {props.isMobileDevice && props.isAuthenticated ? (
                  <></>
                ) : (
                  <>
                    <div className="logo text-center">
                      <Link to="/">
                        <img
                          src={
                            require("../assets/images/new-landing/logo.png")
                              .default
                          }
                          alt="Joker Casino Logo"
                        />
                      </Link>
                    </div>
                  </>
                )}
              </div>
              <div className="col-4 col-md-5">
                <ul className="header_right_menu">
                  {props.isAuthenticated && (
                    <>
                      <li>
                        <CashierModals {...props} />
                      </li>
                      <li>
                        <Link
                          to="/dashboard/account-details"
                          className={"user_icon d-none " + props.landingType}
                          onClick={() => {
                            props.setShowLeftSidebar(true);
                            setTimeout(function () {
                              props.setShowLeftSidebar(false);
                            }, 500);
                          }}
                        >
                          <svg
                            width="22"
                            height="22"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 640 512"
                          >
                            <path
                              fill="#ffffff"
                              d="M637 161.1l-19.1-19.2c-4-4.1-10.6-4.1-14.6 0L500.2 245.6l-47.4-47.7c-4-4.1-10.6-4.1-14.6 0L419 217.1c-4 4.1-4 10.6 0 14.7l73.8 74.3c4 4.1 10.6 4.1 14.6 0L637 175.8c4-4 4-10.6 0-14.7zM224 288c79.5 0 144-64.5 144-144S303.5 0 224 0 80 64.5 80 144s64.5 144 144 144zm0-240c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96zm89.6 256c-28.8 0-42.4 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 304 0 364.2 0 438.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-25.6c0-74.2-60.2-134.4-134.4-134.4zM400 464H48v-25.6c0-47.6 38.8-86.4 86.4-86.4 14.6 0 38.3 16 89.6 16 51.7 0 74.9-16 89.6-16 47.6 0 86.4 38.8 86.4 86.4V464z"
                            />
                          </svg>
                        </Link>
                        <UserDropDownMenu {...props} />
                      </li>
                    </>
                  )}
                  {/* {!props.isMobileDevice && (
                    <>
                      <li>
                        <div className=" open_chat">
                          <Dropdown>
                            <Dropdown.Toggle className={props.landingType}>
                              <svg
                                id="SvgjsSvg1001"
                                width="25"
                                height="25"
                                xmlns="http://www.w3.org/2000/svg"
                                version="1.1"
                                xlink="http://www.w3.org/1999/xlink"
                                svgjs="http://svgjs.com/svgjs"
                              >
                                <defs id="SvgjsDefs1002"></defs>
                                <g id="SvgjsG1008">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    svgjs="http://svgjs.com/svgjs"
                                    xlink="http://www.w3.org/1999/xlink"
                                    width="25"
                                    height="25"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      svgjs="http://svgjs.com/svgjs"
                                      xlink="http://www.w3.org/1999/xlink"
                                      width="25"
                                      height="25"
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="25"
                                        height="25"
                                        enable-background="new 0 0 416 416"
                                        viewBox="0 0 416 416"
                                      >
                                        <path
                                          fill="#ffffff"
                                          d="M256 160h-12c-4.4 0-8 3.6-8 8 0 4.4 3.6 8 8 8h12c4.4 0 8-3.6 8-8C264 163.6 260.4 160 256 160zM208 160h-60c-4.4 0-8 3.6-8 8 0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8C216 163.6 212.4 160 208 160zM336 112H148c-4.4 0-8 3.6-8 8 0 4.4 3.6 8 8 8h188c4.4 0 8-3.6 8-8C344 115.6 340.4 112 336 112z"
                                          class="color000 svgShape colorfff coloraa9f4b"
                                        ></path>
                                        <path
                                          fill="#ffffff"
                                          d="M376,32H104c-22,0-40,18-40,40v88H24c-13.2,0-24,10.8-24,24v128c0,13.2,10.8,24,24,24h40v40c0,3.2,2,6,4.8,7.2
				c1.2,0.4,2,0.8,3.2,0.8c2,0,4-0.8,5.2-2l49.6-44l0.4-0.4c1.2-1.2,2.8-1.6,5.2-1.6h52c13.2,0,24-10.8,24-24v-56h7.2
				c6,0,11.6,2,16,6.4l74.8,69.2c1.6,1.2,3.6,2,5.6,2c1.2,0,2-0.4,3.2-0.8c2.8-1.2,4.8-4,4.8-7.2V256h56c22,0,40-18,40-40V72
				C416,50,398,32,376,32z M192.4,312c0,4.4-3.6,8-8,8h-52c-6.4,0-12,2-16.4,6l-36,32v-30c0-4.4-3.6-8-8-8H24c-4.4,0-8-3.6-8-8V184
				c0-4.4,3.6-8,8-8h40v40c0,22,18,40,40,40h88.4V312z M400,216c0,13.2-10.8,24-24,24h-56v-24c0-4.4-3.6-8-8-8c-4.4,0-8,3.6-8,8
				v91.2l-61.2-56.8c-7.2-6.8-16.8-10.4-27.2-10.4H104c-13.2,0-24-10.8-24-24V72c0-13.2,10.8-24,24-24h272c13.2,0,24,10.8,24,24V216
				z"
                                          class="color000 svgShape colorfff coloraa9f4b"
                                        ></path>
                                      </svg>
                                    </svg>
                                  </svg>
                                </g>
                              </svg>
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                              <div className="modal_top_arrow"></div>
                              <Dropdown.Item
                                onClick={() => {
                                  props.setIsChatVisible(false);
                                  props.setSupportSidebarOpen(true);
                                }}
                                className={props.landingType}
                              >
                                {__("Support Chat")}
                              </Dropdown.Item>
                              {props.isAuthenticated && (
                                <Dropdown.Item
                                  className={props.landingType}
                                  onClick={() => {
                                    props.setIsChatVisible(true);
                                    props.setSupportSidebarOpen(false);
                                  }}
                                >
                                  {__("Players forum")}
                                </Dropdown.Item>
                              )}
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      </li>
                      <li>
                        <LanguageSwitcher {...props} />
                      </li>
                    </>
                  )} */}
                  {!props.isAuthenticated && (
                    <li>
                      <div className="signup_area">
                        <Link
                          onClick={() => {
                            props.setModalLoginPropsData(true);
                          }}
                        >
                          {__("Login")}
                        </Link>
                      </div>
                    </li>
                  )}

                  {!props.isAuthenticated && !props.isMobileDevice && (
                    <li className="hidden_lg">
                      <div className="signup_area">
                        <Link
                          onClick={() => {
                            props.setModalSignUpPropsData(true);
                          }}
                        >
                          {__("Register")}
                        </Link>
                      </div>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </div>
          {props.showSideNav && (
            <>
              <SideNav {...props} />
              <div
                onClick={() => {
                  props.setShowSideNav(false);
                }}
                className="main_overlay"
              ></div>
            </>
          )}
        </section>
      </header>

      {/* <RightSidebar
        userBalance={props.userBalance}
        userDetails={props.userDetails}
        accountProgress={props.accountProgress}
        rightSidebarOpen={rightSidebarOpen}
        toggleRightSidebar={toggleRightSidebar}
        setShowVaultModal={props.setShowVaultModal}
      /> */}
      {/* <LeftSidebar {...props} /> */}
      {/* <VaultModals {...props} /> */}
    </>
  );
};

export default Header;
